import React, { createContext, useContext, useState, useEffect } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "it";
    return localStorage.getItem("lasala_lang") || "it";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("lasala_lang", lang);
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const t = translations[lang];
  const toggle = () => setLang((l) => (l === "it" ? "en" : "it"));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
